import React, { JSX } from 'react'
import * as S from './styles'

import Loading from '@/components/Loading'

interface FormBoxProps {
  html: JSX.Element
  isLoading: boolean
  loadingClass: string
}

const FormBox = ({ html, isLoading, loadingClass }: FormBoxProps) => {
  return (
    <S.FormBoxContainer id="formBox" className="margin-small">
      {isLoading ? <Loading className={loadingClass} /> : html}
    </S.FormBoxContainer>
  )
}

export default FormBox
